import { DropDownBase } from '@syncfusion/ej2-dropdowns';

export const enableAlphabeticalDropdownSorting = () => {
  const dropDownPrototype = DropDownBase.prototype as any;
  if (dropDownPrototype.sortAlphabeticallyPatched) {
    return;
  }

  const setListData = dropDownPrototype.setListData;
  if (typeof setListData !== 'function') {
    return;
  }

  dropDownPrototype.setListData = function (...args: any[]) {
    // if (!this.sortOrder || this.sortOrder === 'None') {
    //   this.sortOrder = 'Ascending';
    // }
    if (this.allowFiltering) {
      this.filterType = 'Contains';
    }

    return setListData.apply(this, args);
  };
  dropDownPrototype.sortAlphabeticallyPatched = true;
};
